__turbopack_context__.v({
  "bannerContainer": "bonuses-module-sass-module__m8j2PG__bannerContainer",
  "bonusesAviator": "bonuses-module-sass-module__m8j2PG__bonusesAviator",
  "bonusesTurnovers": "bonuses-module-sass-module__m8j2PG__bonusesTurnovers",
  "casinoGameInfo": "bonuses-module-sass-module__m8j2PG__casinoGameInfo",
  "content": "bonuses-module-sass-module__m8j2PG__content",
  "header": "bonuses-module-sass-module__m8j2PG__header",
  "numeric": "bonuses-module-sass-module__m8j2PG__numeric",
  "promoHeading": "bonuses-module-sass-module__m8j2PG__promoHeading",
  "promotionsList": "bonuses-module-sass-module__m8j2PG__promotionsList",
  "providerLogo": "bonuses-module-sass-module__m8j2PG__providerLogo",
  "referralBottomTxt": "bonuses-module-sass-module__m8j2PG__referralBottomTxt",
  "star": "bonuses-module-sass-module__m8j2PG__star",
  "starAnimation": "bonuses-module-sass-module__m8j2PG__starAnimation",
  "starred": "bonuses-module-sass-module__m8j2PG__starred",
  "starredAnimation": "bonuses-module-sass-module__m8j2PG__starredAnimation",
  "users": "bonuses-module-sass-module__m8j2PG__users",
});
